module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Økonomi",
      "identifier": "economy"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Økonomi</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet økonomisk overblik over din virksomhed\n            ")])]), _vm._v(" "), (_vm.$route.name === 'EconomyOperations' && _vm.$auth.user().roles[0].name !== 'department-responsible') ? _c('view-toggle', {
    attrs: {
      "operationsName": "Drift",
      "operationsLink": "EconomyOperations",
      "learningName": "Økonomi",
      "learningLink": "EconomyLearning"
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f59a4e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/economy.vue
// module id = 881
// module chunks = 0